import React, { useState } from "react";
import Debuginput from "./Debuginput";
import { useToasts } from "react-toast-notifications";
import Debugoutput from "./Debugoutput";
import { MIN_DIRECTION, MAX_DIRECTION } from "../utils/constants";

/**
 * Computing Component for Circular Tunnel
 * Allows computing discontinuity orientation from log plot (P2, P4, P5 values)
 */
const Computing = (props) => {
  const { addToast } = useToasts();
  const details = {
    direction: 120,
    inclination: 0,
    height: 8,
    hw: 5,
    width: 6,
    widthspl: 8,
    startrd: 0,
    endrd: 80,
    radiusofcrown: 3,
    p2: 70,
    p4: 45,
    p5: 80,
  };
  const [dimensions, setDimensions] = useState(details);
  const [isOutput, setIsOutput] = useState(false);
  const [isDebug, setDebug] = useState(false);

  /**
   * Update dimension value with validation
   * @param {Object} e - Event object
   */
  const updateDimension = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    if (name === "direction" && (e.target.value < MIN_DIRECTION || e.target.value >= MAX_DIRECTION)) {
      addToast(`Oops! Please choose the input value between ${MIN_DIRECTION} and ${MAX_DIRECTION - 1}`, {
        appearance: "error",
      });
      return false;
    }
    if (
      name === "inclination" &&
      (e.target.value < 0 || e.target.value > 89 || e.target.value % 1 !== 0)
    ) {
      addToast("Tunnel Inclination must be an integer between 0 and 89", {
        appearance: "error",
      });
      return false;
    }
    if (name === "width" && (e.target.value < 0 || e.target.value > 25)) {
      addToast("Oops! Please choose the input value between 2 and 25", {
        appearance: "error",
      });
      return false;
    }
    if (name === "widthspl" && (e.target.value < 0 || e.target.value > 25)) {
      addToast("Oops! Please choose the input value between 2 and 25", {
        appearance: "error",
      });
      return false;
    }
    if (name === "height" && (e.target.value < 0 || e.target.value > 40)) {
      addToast("Oops! Please choose the input value between 3 and 40", {
        appearance: "error",
      });
      return false;
    }
    if (name === "hw" && (e.target.value < 0 || e.target.value > 25)) {
      addToast("Oops! Please choose the input value between 2 and 25", {
        appearance: "error",
      });
      return false;
    }
    if (name === "startrd" && (e.target.value < 0 || e.target.value > 50000)) {
      addToast("Oops! Please choose the input value between 0 and 50000", {
        appearance: "error",
      });
      return false;
    }
    const newdim = { ...dimensions };
    newdim[name] = value;
    setDimensions(newdim);
  };

  const showOutput = () => {
    if (dimensions.width < 2) {
      addToast("Oops! Please choose the Tunnel Width value between 2 and 25", {
        appearance: "error",
      });
      return false;
    }
    if (dimensions.widthspl < 2) {
      addToast("Oops! Please choose the Width at Spl value between 2 and 25", {
        appearance: "error",
      });
      return false;
    }
    if (dimensions.height < 3) {
      addToast("Oops! Please choose the Tunnel Height value between 3 and 40", {
        appearance: "error",
      });
      return false;
    }
    if (dimensions.hw < 2) {
      addToast("Oops! Please choose the Tunnel Wall Height value between 2 and 25", {
        appearance: "error",
      });
      return false;
    }
    if (dimensions.endrd < dimensions.startrd + 10 || dimensions.endrd > dimensions.startrd + 150) {
      addToast(
        "Oops! Please choose the End Chainage (m) value between " + (dimensions.startrd + 10) + " and " + (dimensions.startrd + 150),
        {
          appearance: "error",
        }
      );
      return false;
    }
    setIsOutput(true);
    setDebug(false);
  };

  const showInput = () => {
    setIsOutput(false);
    setDebug(false);
  };

  // Reset Values button: zero every field shown on the input form
  const resetValues = () => {
    setDimensions({
      ...details,
      direction: 0,
      inclination: 0,
      radiusofcrown: 0,
      p2: 0,
      p4: 0,
      p5: 0,
    });
  };

  return !isOutput ? (
    <Debuginput label="Proceed"
      showobjective={() => props.setstep("objective")} dimensions={dimensions} updatedimension={updateDimension} showoutput={showOutput} resetvalues={resetValues} />
  ) : (
    <Debugoutput showinput={showInput} showdebug={isDebug} setshowdebug={setDebug} dimensions={dimensions} />
  );
};

export default Computing;
